module.exports = __webpack_public_path__ + "static/team-time-tracking-2f7265f258a0ab1247ae9d62d9271222.jpg";